import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useDeleteContact from '../../../../hooks/dashboard/trip-log/useDeleteContact';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { TableContext } from '../../../Table/TableContext';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface DeleteContactModalProps {
  data: any;
}

const DeleteContactModal: React.FC<DeleteContactModalProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const tableContext = useContext(TableContext);
  const { deleteContact, loading } = useDeleteContact();

  return (
    <Container>
      <ModalContainer
        label='Delete Contact'
        showSuccessComponent={modalContext?.showSuccessComponent}
      >
        <Description>Are you sure you want to delete this contact</Description>
        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            btnType='button'
            onClick={() => modalContext?.setShowModal(false)}
          >
            Cancel
          </FormSubmitButton>

          <FormSubmitButton
            loading={loading}
            btnType='button'
            onClick={() =>
              deleteContact(data?.id, () => {
                modalContext?.setShowModal(!modalContext?.showModal);
                tableContext?.setRefreshTable(!tableContext.refreshTable);
              })
            }
            className='fill red'
          >
            Delete
          </FormSubmitButton>
        </ButtonArea>
      </ModalContainer>
    </Container>
  );
};

export default DeleteContactModal;

const Container = styled.div`
  flex-direction: column;
  gap: 12px;
  display: flex;
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  /* margin-left: auto; */
`;

const Description = styled.div`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
`;
